import { jsx as _jsx } from "react/jsx-runtime";
import { FluentProvider } from '@fluentui/react-components';
import { createContext, useContext, useEffect, useMemo, useState, } from 'react';
import { useTeamsHost } from '#src/teams/TeamsHostProvider.js';
import { resolveTheme, THEME_PREFERENCES, } from '#src/theme/theme.js';
const STORAGE_KEY = 'teams-kit.theme';
const DARK_QUERY = '(prefers-color-scheme: dark)';
const ThemeContext = createContext(null);
/** A preferência é conveniência da pessoa: sem armazenamento, volta a "sistema". */
function readPreference() {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        return THEME_PREFERENCES.find((p) => p === saved) ?? 'system';
    }
    catch {
        return 'system';
    }
}
function savePreference(preference) {
    try {
        localStorage.setItem(STORAGE_KEY, preference);
    }
    catch {
        // Sem armazenamento a escolha vale só até recarregar a página.
    }
}
function useSystemPrefersDark() {
    const [dark, setDark] = useState(() => matchMedia(DARK_QUERY).matches);
    useEffect(() => {
        const query = matchMedia(DARK_QUERY);
        const update = () => setDark(query.matches);
        query.addEventListener('change', update);
        return () => query.removeEventListener('change', update);
    }, []);
    return dark;
}
export function ThemeProvider({ children }) {
    const host = useTeamsHost();
    const [preference, setPreferenceState] = useState(readPreference);
    const [teamsTheme, setTeamsTheme] = useState(host?.theme ?? null);
    const systemPrefersDark = useSystemPrefersDark();
    useEffect(() => host?.onThemeChange(setTeamsTheme), [host]);
    const value = useMemo(() => ({
        preference,
        setPreference(next) {
            savePreference(next);
            setPreferenceState(next);
        },
    }), [preference]);
    const theme = resolveTheme({ preference, teamsTheme, systemPrefersDark });
    return (_jsx(ThemeContext.Provider, { value: value, children: _jsx(FluentProvider, { theme: theme, style: { height: '100%' }, children: children }) }));
}
export function useThemePreference() {
    const value = useContext(ThemeContext);
    if (value === null) {
        throw new Error('useThemePreference fora do ThemeProvider');
    }
    return value;
}
//# sourceMappingURL=ThemeProvider.js.map